import { useEffect } from "react";
import {
  type RouteDock,
  dockedQuery,
  railQuery,
  useShellStore,
} from "../stores/shellStore";

export const useShellStoreEffects = (
  pathname: string,
  routeDock: RouteDock,
) => {
  useEffect(() => {
    const { clearDockContentOverride, closeDock } = useShellStore.getState();
    clearDockContentOverride();
    if (routeDock === "none") closeDock();
  }, [pathname, routeDock]);

  useEffect(() => {
    const lists = [railQuery, dockedQuery].map((query) =>
      window.matchMedia(query),
    );
    const onChange = (event: MediaQueryListEvent) => {
      if (event.matches) useShellStore.getState().closeOverlays();
    };

    lists.forEach((list) => list.addEventListener("change", onChange));
    return () =>
      lists.forEach((list) => list.removeEventListener("change", onChange));
  }, []);
};
